import Icon from '@components/common/Icon';
import ImageCard from '@components/common/ImageCard';
import { DATA_BASE_URL } from '@lib/constants';

const teams = [
  {
    name: 'FRC Team',
    tagline: 'Philippines\' First FRC Team',
    description: 'Co-founded Philippines first FRC team by pooling funds and scouting for sponsorships. Secured a USD 2,000 grant and expanded the team from 10 to 45 members. The team competed on the international stage in Sydney, bringing home the Rookie Inspiration Award.',
    image: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_team_photo_2024.webp`,
    highlights: [
      'FRC Rookie Inspiration award-24',
      'Sydney Regional Competition',
      'FRC Taipei regionals tournament finalist award-25',
      'Pioneered FRC in the Philippines'
    ],
    stats: [
      { label: 'Founded', value: '2024' },
      { label: 'Competitions', value: '5+' },
      { label: 'Awards', value: '3' }
    ]
  },
  {
    name: 'VEX Robotics',
    tagline: 'From Nationals to Worlds',
    description: 'Leading VEX robotics teams through multiple seasons (2023-2025), from local and national competitions to the VEX Worlds Championship in Dallas. I specialize in autonomous programming and mechanical design.',
    image: `${DATA_BASE_URL}/data/robotics/images/vex_taipei_2025_1.webp`,
    highlights: [
      'Vex National Robot excellence award(x2)-23, 25',
      'Vex National Robot Skills award(x2) - 23, 25',
      'Vex National Tournament Champion award-23',
      'Vex National Robot Design award-24',
      'Vex National Tournament Finalist award-24',
      'Vex National tournament Judges award-24',
      'Create award - Formosa, Taipei-24'
    ],
    stats: [
      { label: 'Started', value: '2022' },
      { label: 'Competitions', value: '10+' },
      { label: 'Awards', value: '7+' }
    ]
  }
];

const TeamsOverviewSection = () => {
  return (
    <section className="py-16 sm:py-20 px-4">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-12">
          <h2
            className="text-3xl sm:text-4xl font-heading font-bold mb-4 tracking-tight"
            style={{ color: 'var(--color-heading)' }}
          >
            Team Leadership
          </h2>
          <p
            className="text-lg max-w-2xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            Leading robotics excellence across two major competition platforms
          </p>
        </div>

        <div className="space-y-12">
          {teams.map((team, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-center ${
                index % 2 === 1 ? 'lg:grid-flow-dense' : ''
              }`}
            >
              {/* Image */}
              <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                <div
                  className="rounded-xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-200"
                  style={{
                    backgroundColor: 'var(--color-card-bg)',
                    borderColor: 'var(--color-border-light)',
                    borderWidth: '1px',
                    borderStyle: 'solid'
                  }}
                >
                  <ImageCard
                    src={team.image}
                    alt={team.name}
                    aspectRatio="aspect-video"
                    rounded={false}
                    shadow={false}
                  />
                </div>
              </div>

              {/* Content */}
              <div className={index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}>
                <div className="space-y-6">
                  <div className="flex items-center gap-3">
                    <div
                      className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: 'var(--color-accent-1)' }}
                    >
                      <Icon name="robotics" size="lg" style={{ color: 'var(--color-accent-7)' }} />
                    </div>
                    <div>
                      <h3
                        className="text-2xl sm:text-3xl font-bold"
                        style={{ color: 'var(--color-heading)' }}
                      >
                        {team.name}
                      </h3>
                      <p
                        className="text-sm font-medium"
                        style={{ color: 'var(--color-accent-6)' }}
                      >
                        {team.tagline}
                      </p>
                    </div>
                  </div>

                  <p
                    className="text-base leading-relaxed"
                    style={{ color: 'var(--color-card-text)' }}
                  >
                    {team.description}
                  </p>

                  {/* Highlights */}
                  <ul className="space-y-2">
                    {team.highlights.map((highlight, i) => (
                      <li
                        key={i}
                        className="flex items-start text-sm"
                        style={{ color: 'var(--color-muted)' }}
                      >
                        <span className="mr-2 mt-1 flex-shrink-0" style={{ color: 'var(--color-accent-6)' }}>
                          ✓
                        </span>
                        {highlight}
                      </li>
                    ))}
                  </ul>

                  {/* Mini Stats */}
                  <div className="flex gap-4 pt-2">
                    {team.stats.map((stat, i) => (
                      <div key={i} className="text-center">
                        <div
                          className="text-2xl font-bold"
                          style={{ color: 'var(--color-accent-7)' }}
                        >
                          {stat.value}
                        </div>
                        <div
                          className="text-xs font-medium"
                          style={{ color: 'var(--color-muted)' }}
                        >
                          {stat.label}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamsOverviewSection;
